import { MensajeService } from './../../../modulo_compartido/mensaje/mensaje.service';
import { DropService } from './drop.service';
import { Subject } from 'rxjs/Subject';
import { Cupo, Cita, Contenedor } from 'app/view/impo/impo';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { EmptyEnumClass, TypeCheckEnum } from '../type-check-enum';

@Component({
	moduleId: module.id,
	selector: 'app-drop-area-type-check',
	template: `
    <span *ngIf="cupo.estadoCupo != 'ND'" class="box-conta" [ngClass]="{'ocupado' : cupo.estadoCupo == 'O','nodisponible' : cupo.estadoCupo == 'ND','disponible' : cupo.estadoCupo == 'D'}" dropDirective (dropEvent)="addDropItem($event,cupo)" (dragenterEvent)="dragEnter($event,cupo.estadoCupo)" (dragleaveEvent)="dragLeave()">
		
		<div [ngClass]="{'ocupado' : cupo.estadoCupo == 'O','nodisponible' : cupo.estadoCupo == 'ND','disponible' : cupo.estadoCupo == 'D'}" *ngIf="itemsDroppedRound?.length == 0">
			{{cupo.estadoCupo == 'O' ? "ocupado" : cupo.estadoCupo == 'D' ? "disponible" : cupo.estadoCupo == 'ND' ? "no disponible" :""}}
		</div>

		<div *ngIf="itemsDroppedRound?.length == 1" class="ocupado">
			<app-generic-box *ngFor="let item of itemsDroppedRound" [contenedor]='item' [cupo]="cupo" (click)="itemsDroppedRound=[]; deleteDropItem(item,cupo)"></app-generic-box>
		</div>

    </span>
	`
})
export class DropAreaTypeCheckComponent {

	@Input() cupo: Cupo;
	@Output() droppedItemType: EventEmitter<any> = new EventEmitter();

	itemsDroppedRound: Array<any> = [];
	private warningMessage: string = '';
	private highlight: Array<string> = ['', ''];
	private typeCheck = TypeCheckEnum;

	//[ngClass]="{'ocupado' : cupo.estadoCupo == 'O', 'disponible' : cupo.estadoCupo == 'D','nodisponible' : cupo.estadoCupo == 'ND'}" 


	constructor(private drop: DropService, private sms: MensajeService) {

	}


	addDropItem(event, cupo) {
		if (this.itemsDroppedRound.length < 1) {
			this.itemsDroppedRound["estado"] = "O";
			cupo.nroContenedor = event.nroContenedor;
			cupo.nroDetalleDTO = event.nroDetalleDo;
			cupo.transaccionId = event.transaccionId
			this.itemsDroppedRound.push(event);
			this.drop.agregarCupo(cupo);

		} else {
			cupo.nroContenedor = event.nroContenedor;
			this.deleteDropItem(event, cupo);
			this.sms.enviarAlerta({ mensaje: "El cupo ya esta ocupado", tipo: 3 });
		}
	}

	private deleteDropItem(event, cupo) {
		cupo.nroContenedor = event.nroContenedor;
		this.drop.eliminarCupo(cupo);
	}




	dragEnter(event, type) {
		//console.log("drag enter");
		if (event.type !== type) {
			this.highlight[type] = 'badHighlight';
		} else {
			this.highlight[type] = 'highlight';
		}
	}

	dragLeave() {
		//console.log("dragleave");
		this.highlight = ['', ''];
	}
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/drags/type-check/drop-area-type-check/drop-area-type-check.component.ts